





























































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import SetCode from './setCode.vue';
import userService from "@/service/userService";
import { AppUtil } from '../../utils/app.util';
import { State, Action, Getter } from 'vuex-class'

//登录模式
@Component({
  components: { SetCode }
})
export default class Login extends Vue {
  private loginType: string = 'passwd'; // 登录方式 passwd 密码登录 code 验证码登录
  private name: string = ''; // 用户名
  private passwd: string = ''; // 密码
  private code: string = ''; //   验证码
  private pwdType: string = 'password'; // 密码类型
  private appInfoAtiak: any = userService.appInfoAtiak; // 应用信息
  private loging: boolean = false;
  @Action('SET_USER_INFO_ASYN') setUserInfo!: (data: any) => void
  // private loginMode: number; //0:短信|密码 1:短信 2:密码
  @Action('SET_ACCOUNT_DIALOG_TYPE_ASYN') changeAccountType!: (data: string) => void
  @Action('SET_SHOW_ACCOUNT_DIALOG_ASYN') handleAccountDialog!: (data: boolean) => void
  pwdShow() {
    this.pwdType = this.pwdType == 'password' ? 'text' : 'password';
  }

  getSendCode(res: any) { // 获取验证码
    console.log('sendCode', res);
  }

  setLoginType(_loginType: string) {
    if (_loginType == 'code' || _loginType == 'passwd') {
      this.loginType = _loginType;
    } else {
      //其他错误情况默认到验证码登录
      this.loginType = 'code';
    }
    this.passwd = '';
    // this.setName(); //从缓存中设置默认账号

  }
  // 去注册
  toRegister() {
    this.changeAccountType('register')
  }
  // 忘记密码
  openSetPasswd() {
    this.changeAccountType('setPasswd')
  }

  login() {
    // 三种登录形式，手机号+验证码|手机号+密码|用户名+密码
    if (!this.loging) {
      if (this.loginType == 'code') {
        this.phoneCodeLogin();
      } else {
        this.passwdLogin();
      }
    }
  }
  phoneCodeLogin() {
    // 手机号&验证码
    /*  if (this.loginMode != 0 && this.loginMode != 1) {
       this.$Message.error('登录失败，此机构未开放短信登录权限!');
       return;
     } */
    if (this.validPhone() && this.validCode()) {
      this.loging = true;
      userService
        .caccountLogin({
          loginNameType: 'MOBILE',
          loginName: this.name,
          smsCode: this.code,
          atiak: this.appInfoAtiak,
        })
        .then((data: any) => {
          this.processLogin(data);
          this.loging = false;
        }).catch((err: any) => {
          console.log('err', err);
        });
    }
  }

  passwdLogin() {
    // 手机号|用户名&密码
    if (AppUtil.isEmpty(this.name)) {
      this.$Message.error('用户名不能为空!');
      return;
    } else if (AppUtil.isEmpty(this.passwd)) {
      this.$Message.error('密码不能为空!');
      return;
    }
    this.loging = true;
    userService
      .caccountLogin({
        loginNameType: 'USERNAME',
        loginName: this.name,
        password: this.passwd,
        atiak: this.appInfoAtiak,
      })
      .then((data: any) => {
        this.processLogin(data);
        this.loging = false;
      });
  }
  validPhone(): boolean {
    if (AppUtil.isEmpty(this.name)) {
      this.$Message.error('手机号不能为空!');
      return false;
    } else if (!AppUtil.isPhoneNumber(this.name)) {
      this.$Message.error('请输入正确的手机号!');
      return false;
    }
    return true;
  }

  validCode(): boolean {
    if (AppUtil.isEmpty(this.code)) {
      this.$Message.error('请输入验证码!');
      return false;
    } else if (this.code.length != 6) {
      this.$Message.error('验证码不正确!');
      return false;
    }
    return true;
  }
  // 统一处理登录返回信息
  private processLogin(data: any) {
    if (data && data.success) {
      if (data.result && data.result.account) {
        // 如果非当前机构的用户，需要重定向到对应机构
        if (AppUtil.isNotEmpty(data.result.orgDomain) && data.result.orgDomain != AppUtil.getHostName()) {
          let autoLoginToken = userService.generateAutoLoginInfo(data);
          if (autoLoginToken != null) {
            window.location.href = '//' + data.result.orgDomain + '/index';
          } else {
            this.$Message.error('用户登录失败!');
          }
          return;
        } else {
          userService.saveLoginedInfo(data, false);
          this.$Message.success('登录成功!');
          this.handleAccountDialog(false)
          this.setUserInfo(data.result.account)
        }
      } else {
        this.$Message.error('用户登录失败!');
      }
    } else if (data.errorCode == 10) {
      this.loging = false;
      this.$Message.error('用户登录失败!');
    } else if (data.errorCode == '05155') {
      this.loging = false;
      this.$Modal.confirm({
        title: '提示',
        content: '当前手机号未绑定账号，请使用账号密码登录或注册新账号!',
        okText: '去登录',
        cancelText: '立即注册',
        onOk: () => {
          this.name = ""
          this.loginType = 'passwd';
        },
        onCancel: () => {
          this.handleAccountDialog(true)
          this.changeAccountType('register')
        }
      });
    } else {
      this.$Message.error(data.errorText);
    }
  }
  // 打开协议地址
  openxy(index: number) {
    let uri = index == 0 ? 'sxyyzc' : 'sxysxy';
    let url = '//html.chineseall.cn/assets/html/' + uri + '/index.html';
    window.open(url, '_blank');
  }
}
